import APIService from '@/services/APIService';

export default {
  getPriorRecordUsers(params) {
    return APIService.get('/prior-record-users/', { params });
  },
  getDiplomaSettings(params) {
    return APIService.get('/organization-diploma-settings/', { params });
  },
  createDiplomaSettings(payload) {
    return APIService.post('/organization-diploma-settings/', payload);
  },
  updateDiplomaSettings(id, payload) {
    return APIService.put(`/organization-diploma-settings/${id}`, payload);
  },
  createDiplomas(payload, params) {
    return APIService.post('/diplomas/', payload, params);
  },
  getDiplomas(params) {
    return APIService.get('/diplomas/', { params });
  },
  showDiploma(id, params) {
    return APIService.get(`/diplomas/${id}`, { params });
  },
  courseTypeSettings(params) {
    return APIService.get('/organization-course-type-settings/', { params });
  },
  saveCourseTypeSettings(payload) {
    return APIService.post('/organization-course-type-settings/', payload);
  },

  orgDownloadDiploma(id) {
    return APIService.get(`/diplomas/${id}/org-download`, { responseType: 'blob' });
  },
  orgDownloadDiplomaPreview(id) {
    return APIService.get(`/diplomas/${id}/org-download-preview`, { responseType: 'blob' });
  },
  userDownloadDiploma(id, payload) {
    return APIService.post(`/diplomas/${id}/user-download`, payload, { responseType: 'blob' });
  },
  downloadByQr(hash) {
    return APIService.get(`/diplomas/show/${hash}`, { responseType: 'blob' });
  },

  signDiploma(id, payload) {
    return APIService.post(`diplomas/${id}/sign-document`, payload);
  },
  signMassDiploma(payload) {
    return APIService.post('/diplomas/mass-sign-document', payload);
  },

  exportJournal(payload) {
    return APIService.post('/exports/diplomas/journal', payload, { responseType: 'blob' });
  },
  exportFisFrdo(payload) {
    return APIService.post('/exports/diplomas/form-fis-frdo', payload, { responseType: 'blob' });
  },

  getTrainingNotes(params) {
    return APIService.get('/training-notes', { params });
  },
  downloadTrainingNote(id, params) {
    return APIService.get(`/training-notes/${id}/pdf`, { params, responseType: 'blob' });
  },
};
